import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const HRCalendarTable = ({ 
    data, 
    onEdit, 
    onDelete,
    loading, 
    currentPage,
    setCurrentPage,
    currentYearId
}) => {
  const headers = [
    "ID", 
    "Year", 
    "Status", 
    "Current Year", 
    "Actions"
  ];

  // MODIFIED: Changed accessors to use display-specific keys
  const accessors = [
    "id", 
    "year", 
    "isActiveDisplay", 
    "isCurrentYearDisplay", 
    "actions"
  ];

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: (row) => row.id !== currentYearId, // Disable edit for current year
    },
    {
      name: "Delete",
      tooltip: "delete",
      icon: <DeleteIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600 flex items-center",
      function: onDelete,
      visible: (row) => row.id !== currentYearId, // Prevent deletion of current year
    },
  ];

  // Transform data for display without overwriting original boolean values
  const transformedData = data.map(item => ({
    ...item,
    // ADDED: New keys for display so the original booleans stay intact for the Edit function
    isActiveDisplay: item.isActive ? "Active" : "Inactive",
    isCurrentYearDisplay: item.isCurrentYear ? "True" : "False"
  }));

  return (
    <CreateTable
      tableName={"HR Calendar List"}
      headers={headers}
      accessors={accessors}
      data={transformedData}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
    />
  );
};

export default HRCalendarTable;